import { Component } from '@angular/core';
import { UserContextService } from '@benefitsui/app/services/user-context/user-context.service';
import { UserRole } from '@benefitsui/app/shared/enums/users';
import { environment } from '@benefitsui/environments/environment';

interface IDetailsPageLabels {
  buttonLabel: string;
  buttonUrl: string;
  cardBody: string;
}

@Component({
  selector: 'app-claim-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class ClaimDetailsComponent {
  detailsButtonLabel = '';
  detailsURL = '';
  cardBody = '';

  constructor(private userContextService: UserContextService) {
    const userType = userContextService.get().symClass;

    const detailFillerFunction = this.getPageDetailsFiller(userType.toLowerCase());
    const { buttonLabel, buttonUrl, cardBody } = detailFillerFunction();

    this.detailsButtonLabel = buttonLabel;
    this.detailsURL = buttonUrl;
    this.cardBody = cardBody;
  }

  getEmployeePageDetails(): IDetailsPageLabels {
    return {
      buttonLabel: 'Visit LAMS',
      buttonUrl: environment.claimDetailEmployeeCTAUrl,
      cardBody: `Check back soon for our improved experience. In the meantime, please visit the Life Absence Management Systems (LAMS) if you have access.`
    };
  }

  getPolicyHolderPageDetails(): IDetailsPageLabels {
    return {
      buttonLabel: 'Visit the Claims Management Portal',
      buttonUrl: environment.claimDetailPolicyHolderCTAUrl,
      cardBody: `Check back soon for our improved experience. In the meantime, please visit the Claims Management Portal and navigate to the desired claim.`
    };
  }

  getPageDetailsFiller(userType: string): () => IDetailsPageLabels {
    let detailFillerFunction;
    switch (userType) {
      case UserRole.Employee:
        detailFillerFunction = this.getEmployeePageDetails;
        break;
      default:
        detailFillerFunction = this.getPolicyHolderPageDetails;
        break;
    }

    return detailFillerFunction;
  }
}
